import { useCallback, useState } from 'react';

const DEFAULT_PAGE_SIZE = 25;

export function useCursorPagination(pageSize = DEFAULT_PAGE_SIZE) {
  const [page, setPage] = useState(0);
  const [cursors, setCursors] = useState<(string | undefined)[]>([undefined]);

  const cursor = cursors[page];

  const reset = useCallback(() => {
    setPage(0);
    setCursors([undefined]);
  }, []);

  const goNext = useCallback(
    (nextCursor: string | null) => {
      if (!nextCursor) return;
      setCursors((prev) => {
        const next = [...prev];
        next[page + 1] = nextCursor;
        return next;
      });
      setPage((p) => p + 1);
    },
    [page],
  );

  const goPrev = useCallback(() => {
    if (page > 0) {
      setPage((p) => p - 1);
    }
  }, [page]);

  return {
    page,
    pageSize,
    cursor,
    canPrev: page > 0,
    pageNumber: page + 1,
    reset,
    goNext,
    goPrev,
  };
}
